<script>
const variants = ["normal", "danger"];

export default {
    name: "LinkTenantSettingActionLink",
    emits: ["click"],
    props: {
        variant: {
            type: String,
            default: "normal",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        variantClassName() {
            return variants.includes(this.variant) ? `action-link--${this.variant}` : "action-link--normal";
        },
        disabledClassName() {
            return this.disabled ? "action-link--disabled" : "";
        }
    },
}
</script>

<template>
    <button
        :class="['transparent-button', 'action-link', variantClassName, disabledClassName]"
        :disabled="disabled"
        @click="() => $emit('click')"
        type="button"
    >
        <slot></slot>
    </button>
</template>

<style scoped>
.action-link {
    white-space: nowrap;
    padding: 0;
}

.action-link--disabled {
    opacity: 0.3;
    cursor: not-allowed;
}

.action-link--normal {
    color: #5171cb;
}

.action-link--danger {
    color: #d55169;
}
</style>
